

export const image = function({ name }) {
  return require(`@/assets/image/legend/${name}.png`)
}
